import { ReferenceMap } from '../../shared.types';

export const emptyReferenceMapCoreCfn = (): Omit<ReferenceMap, 'id'> => {
	return {
		type: null,
		backsplash: null,
		breakpoint: null,
		breakpoints: null,
		connection: null,
		kitchen: null,
		kitchenDesign: null,
		island: null,
		islands: null,
		obstruction: null,
		obstructions: null,
		countertop: null,
		panel: null,
		panels: null,
		panelItemGroup: null,
		panelItemGroups: null,
		panelItem: null,
		panelTrim: null,
		promotionalSku: null,
		promotionalSkus: null,
		notification: null,
		notifications: null
	};
};
